/**
 * Caller abort composed with a timeout, without `AbortSignal.any` / `AbortSignal.timeout`.
 *
 * Those APIs throw on iOS Safari below 17.4 / 16.0, which is inside our support floor. A TypeError
 * on the first request would turn the whole cashier into a blank error screen for those devices.
 */
export function linkSignals(
  signal: AbortSignal,
  timeoutMs: number,
): {
  signal: AbortSignal;
  cleanup: () => void;
  didTimeout: () => boolean;
} {
  const controller = new AbortController();
  let timedOut = false;

  const onAbort = () => {
    controller.abort(signal.reason);
  };
  const timer = setTimeout(() => {
    timedOut = true;
    controller.abort();
  }, timeoutMs);

  if (signal.aborted) onAbort();
  else signal.addEventListener('abort', onAbort, { once: true });

  // Listener and timer must both be released on every exit path, including success: a poller that
  // leaks one listener per tick leaks for the life of the session.
  return {
    signal: controller.signal,
    cleanup: () => {
      clearTimeout(timer);
      signal.removeEventListener('abort', onAbort);
    },
    didTimeout: () => timedOut,
  };
}
